import React, { useContext, useEffect, lazy, Suspense } from "react";

// components
import { Header } from "../../components/common/header/Header";
import { AppWrapper } from "./MainPage.styled";
import Loader from "../../components/common/loader/Loader";

// context
import { StoreLocatorContext } from "../../context/Context";

import { preventZoomAndScroll, allowZooomAndScroll, getUrlSettings, getCurrentFilter, pushDataLayer } from "../../helpers/helpers";

const List = lazy(() => import("../../components/list/List"));
const DetailsPage = lazy(() => import("../details/DetailsPage"));
const MapWrapper = lazy(() => import("../../components/map/MapWrapper"));

export const MainPage = () => {
	// context
	const { view, initStoreLocator, setInitStoreLocator, setFilterPreset, setUpdatedView, viewRef, previousViewRef, setService, setParamsRecord, setCurrentFilter, loading, exitStoreLoc } =
		useContext(StoreLocatorContext);

	// check if the app webview useragent "An Post" is loaded
	const anPostAppCheck = () => {
		if (navigator.userAgent.indexOf("An Post") !== -1) {
			const header = document.querySelector(".header");
			if (header) header.style.zIndex = 999999;
			return true;
		} else {
			return false;
		}
	};

	useEffect(() => {
		// this function can be called from outside of the react app by the website
		window.showStoreLocator = {};
		window.showStoreLocator.show = hash => {
			// returns settings from the url
			const settings = getUrlSettings(hash);

			// sets the preset filter
			if (settings.types) {
				setFilterPreset(settings.types);

				// if there are multiple types reset the current filter
				if (settings.types.includes("|")) {
					setCurrentFilter({});
				}
			}

			// if there is only one type
			if (settings.types && !settings.types.includes("|")) {
				// set currrent Filter
				setCurrentFilter(getCurrentFilter(settings.types));
			}

			// if there is a service
			if (settings.service) {
				setService(settings.service);
			}

			// this shows the map
			setInitStoreLocator(true);

			// prevent user zooming
			preventZoomAndScroll();

			// check if called from the mobile app and make sure page scrolls back to top to prevent the header from disappearing
			anPostAppCheck() && window.scrollTo(0, 0);

			pushDataLayer({
				event: "apporweb",
				webview: window.webview
			});
		};

		// event called from AP website
		window.showStoreLocator.hide = () => {
			// if toggling backwards using browser back button, hide the store locator
			if (viewRef.current === "details" && !exitStoreLoc.current) {
				// set to the previous view
				setUpdatedView(previousViewRef.current || "map");

				// if the webview app back button is clicked, then scroll down to continue button on previous page if it's available
				if (anPostAppCheck()) {
					const continueBtn = document.querySelector(".app-btn-continue") && document.querySelector(".app-btn-continue");
					if (continueBtn.length > 0) {
						continueBtn.scrollIntoView({ behavior: "smooth" });
					}
				}

				// keep hash value within the store locator
				window.location.hash = "#storelocator";
			} else {
				// reset the record when closing the map
				setParamsRecord({});

				// this hides the map
				setInitStoreLocator(false);

				// re-enable zoom and scroll
				allowZooomAndScroll();
			}
		};
		// to open store locator map automatically on these pages
		if (window.location.pathname.toLowerCase() === "/store-locator" || window.location.pathname.toLowerCase() === "/p33-store-locator-app.html") {
			window.showStoreLocator.show("#storelocator");
		}
	}, []);

	return (
		<>
			{initStoreLocator && (
				<>
					{loading && <Loader />}
					<AppWrapper map={view === "map"} mobileApp={anPostAppCheck()}>
						{!anPostAppCheck() && (
							<Header>
								<h1>Find An Post locations</h1>
							</Header>
						)}
						<Suspense fallback={<AppWrapper />}>
							{view === "map" && <MapWrapper />}
							{view === "list" && <List />}
							{view === "details" && <DetailsPage />}
						</Suspense>
					</AppWrapper>
				</>
			)}
		</>
	);
};
